import React, { useState, useEffect } from 'react';
import { getCookieConsent, setCookieConsent } from '../utils/cookieUtils';

/**
 * Компонент баннера согласия на использование cookies
 * 
 * Функциональность:
 * - Показывается только при первом посещении сайта
 * - Сохраняет выбор пользователя в localStorage
 * - Имеет плавную анимацию появления/исчезновения
 * - Адаптивный дизайн для всех устройств
 * - Ссылка на Политику Cookies
 * 
 * @returns {JSX.Element|null} Компонент баннера или null если согласие уже получено
 */
const CookieBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Проверяем, дал ли пользователь согласие на cookies
    const cookieConsent = getCookieConsent();
    if (!cookieConsent) {
      setShowBanner(true);
      // Показываем баннер с небольшой задержкой для анимации
      setTimeout(() => setIsVisible(true), 100);
    }
  }, []);

  const handleAccept = () => {
    setCookieConsent('accepted');
    setIsVisible(false);
    setTimeout(() => setShowBanner(false), 300);
  };

  const handleDecline = () => {
    setCookieConsent('declined');
    setIsVisible(false);
    setTimeout(() => setShowBanner(false), 300);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className={`cookie-banner ${isVisible ? 'show' : 'hide'}`}>
      <div className='container'>
        <div className='row align-items-center'>
          <div className='col-lg-8 col-md-7'>
            <p className='cookie-text mb-3 mb-lg-0'>
              🍪 Ми використовуємо файли cookie для покращення роботи сайту та аналізу трафіку. 
              Продовжуючи користування сайтом, ви погоджуєтеся з нашою{' '}
              <a 
                href='https://docs.google.com/document/d/1DR9Z0LPC6GlYBlGcBWraCn-sPnsYT7AmQJYASznBNi4/edit?usp=sharing' 
                target='_blank' 
                rel='noopener noreferrer' 
                className='cookie-link'
              >
                Політикою Cookies
              </a>
              .
            </p>
          </div>
          <div className='col-lg-4 col-md-5'>
            <div className='cookie-buttons'>
              <button
                onClick={handleDecline}
                className='cookie-btn decline'
              >
                Відхилити
              </button>
              <button
                onClick={handleAccept}
                className='cookie-btn accept'
              >
                Прийняти
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { CookieBanner };